/* eslint-disable react/prop-types */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { primaryColor } from "resources/constants";
import { BiErrorCircle } from "react-icons/bi";
import { FiAlertCircle, FiCheck } from "react-icons/fi";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    borderBottom: theme.box.border,
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  dialogContent: {
    padding: "25px",
    display: "grid",
    minWidth: "150px",
    alignItems: "center",
    justifyItems: "center",
  },
  messageIcon: {
    width: "75px",
    height: "75px",
  },
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function CompetitorSavingDialog({
  scenarioName,
  actualStatus,
  setSavingStatus,
}) {
  const allStatus = {
    noSaving: "",
    loading: "Loading",
    ok: "Ok",
    error: "Error",
    timeout: "Timeout",
  };
  const classes = useStyles();

  return (
    <Dialog open={![allStatus.ok, allStatus.noSaving].includes(actualStatus)}>
      <DialogTitle className={classes.dialogTitle}>{actualStatus}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {actualStatus === allStatus.loading && (
          <>
            <Typography align="center" variant="body1">
              {scenarioName
                ? `Scenario "${scenarioName || "competitor scenario"}" is
              being set.`
                : "All scenarios competitors is being set."}
            </Typography>
            <br />
            <ScaleLoader
              size={150}
              color={primaryColor}
              loading
              data-testid="spinner"
              className={classes.messageIcon}
            />
          </>
        )}
        {actualStatus === allStatus.error && (
          <>
            <BiErrorCircle className={classes.messageIcon} />
            <br />
            <Typography align="center" variant="body1">
              Error updating competitor. Try again shortly.
            </Typography>
          </>
        )}
        {actualStatus === allStatus.timeout && (
          <>
            <FiAlertCircle className={classes.messageIcon} />
            <Typography align="center" variant="body1">
              Could not update the status of the task.
            </Typography>
          </>
        )}
        {actualStatus === allStatus.ok && (
          <>
            <FiCheck className={classes.messageIcon} />
            <Typography align="center" variant="body1">
              Competitor saved correctly.
            </Typography>
          </>
        )}
      </DialogContent>
      {actualStatus !== allStatus.loading && (
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setSavingStatus(allStatus.noSaving);
            }}
          >
            Close
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
